import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, Title } from "@/components/UI";
import { useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { DownloadIcon, FilePdfIcon } from "@gemini/icons";
import { Card, CellContent, Divider } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { useDocuments } from "@/components/Sections/Documents";
export const Documents = () => {
    const { t } = useI18n();
    const documents = useDocuments();
    const { documentsRef } = useRefsContext();
    const testId = useTestId("Sections.Documents");
    if (!documents)
        return null;
    const { onPress, files } = documents;
    return (_jsxs(Section, { ref: documentsRef, testId: testId, unsafeClassname: "HideOnPrint", children: [_jsx(Title, { variant: "section", title: t("documents.title"), testId: `${testId}.Title` }), _jsx(Card, { testId: `${testId}.Box`, borderRadius: "8", hasPadding: false, children: files.map(({ key, url, title, subtitle }, index) => (_jsxs(Box, { wordBreak: "break-all", children: [_jsx(CellContent, { testId: `${testId}.Document.${index}`, padding: "16", onPress: onPress(url), description: subtitle, title: title, placeholderStart: FilePdfIcon, iconEnd: DownloadIcon }), index !== files.length - 1 && _jsx(Divider, { "aria-hidden": "true" })] }, key))) })] }));
};
